!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("ReactBootstrap_Carousel", ["react"], t) : "object" == typeof exports ? exports.ReactBootstrap_Carousel = t(require("react")) : e.ReactBootstrap_Carousel = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 7);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    var r;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r) && r.length) {
              var a = o.apply(null, r);
              a && e.push(a);
            } else if ("object" === i) for (var u in r) {
              n.call(r, u) && r[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    e.exports = n(3)();
  }, function (e, t, n) {
    "use strict";

    var r = n(4),
        o = n(5),
        i = n(6);

    e.exports = function () {
      function e(e, t, n, r, a, u) {
        u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {};

    e.exports = function (e, t, n, o, i, a, u, c) {
      if (r(t), !e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var s = [n, o, i, a, u, c],
              f = 0;
          (l = new Error(t.replace(/%s/g, function () {
            return s[f++];
          }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        i = n(2),
        a = n.n(i);

    function u(e) {
      return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function c(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function l(e) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function f(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function p(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var y = function (e) {
      function t(e) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), p(f(f(n = function (e, t) {
          return !t || "object" !== u(t) && "function" != typeof t ? f(e) : t;
        }(this, l(t).call(this, e)))), "safeSetState", function (e) {
          !n.isUnmount && n.setState(e);
        }), n.isUnmounted = !1, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, o.a.PureComponent), function (e, t, n) {
        t && c(e.prototype, t), n && c(e, n);
      }(t, [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("beforeunload", this.unmount), window.addEventListener("visibilitychange", this.visibilitychange), "function" == typeof this.init && this.init();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.isUnmount = !0, "function" == typeof this.unmount && this.unmount(), window.removeEventListener("beforeunload", this.unmount), window.removeEventListener("visibilitychange", this.visibilitychange);
        }
      }, {
        key: "render",
        value: function value() {
          return o.a.createElement("div", null, "The Base Component");
        }
      }]), t;
    }();

    p(y, "propTypes", {
      init: a.a.func,
      unmount: a.a.func
    });
    var d = n(1),
        h = n.n(d);

    function b(e) {
      return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function m(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function v(e) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _(e, t) {
      return (_ = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function O(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function g(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var w = function (e) {
      function t(e) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), g(O(O(n = function (e, t) {
          return !t || "object" !== b(t) && "function" != typeof t ? O(e) : t;
        }(this, v(t).call(this, e)))), "_onClick", function (e) {
          var t = n.props.activeIndex < e ? "next" : "prev";
          n.props.indClick(e, t);
        }), n.state = {
          css: "carousel-indicators"
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _(e, t);
      }(t, o.a.PureComponent), function (e, t, n) {
        t && m(e.prototype, t), n && m(e, n);
      }(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.data,
              r = t.activeIndex;

          if (Array.isArray(n)) {
            var i = n.map(function (t, n) {
              var i = n == r ? "active" : "";
              return o.a.createElement("li", {
                key: n,
                onClick: e._onClick.bind(e, n),
                className: i,
                style: {
                  marginLeft: 10
                }
              });
            });
            return o.a.createElement("ol", {
              className: this.state.css
            }, i);
          }

          return null;
        }
      }]), t;
    }();

    function P(e) {
      return (P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function x(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function j(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function S(e, t, n) {
      return t && j(e.prototype, t), n && j(e, n), e;
    }

    function k(e, t) {
      return !t || "object" !== P(t) && "function" != typeof t ? I(e) : t;
    }

    function E(e) {
      return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function C(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && T(e, t);
    }

    function T(e, t) {
      return (T = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function I(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function N(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    g(w, "defaultProps", {
      data: [],
      activeIndex: 0,
      indClick: function indClick() {}
    });

    var R = function (e) {
      function t(e) {
        var n;
        return x(this, t), N(I(I(n = k(this, E(t).call(this, e)))), "_onclick", function (e) {
          n.props.controlsClick(e);
        }), n.state = {}, n;
      }

      return C(t, o.a.PureComponent), S(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.rightIcon,
              n = e.leftIcon,
              r = e.dataLength,
              i = e.version,
              a = "",
              u = "";
          if (r < 2) return null;

          switch (i) {
            case 4:
              a = "left carousel-control-prev", u = "right carousel-control-next", n = n || o.a.createElement("i", {
                className: "icon icon-chevron-left"
              }), t = t || o.a.createElement("i", {
                className: "icon icon-chevron-right"
              });
              break;

            default:
              a = "left carousel-control", u = "right carousel-control", n = n || o.a.createElement("i", {
                className: "glyphicon glyphicon-chevron-left"
              }), t = t || o.a.createElement("i", {
                className: "glyphicon glyphicon-chevron-right"
              });
          }

          return o.a.createElement("div", null, o.a.createElement("a", {
            className: a,
            onClick: this._onclick.bind(this, "prev")
          }, o.a.createElement(A, {
            icon: n
          })), o.a.createElement("a", {
            className: u,
            onClick: this._onclick.bind(this, "next")
          }, o.a.createElement(L, {
            icon: t
          })));
        }
      }]), t;
    }();

    N(R, "defaultProps", {
      dataLength: 0,
      controlsClick: function controlsClick() {},
      version: 3
    });

    var L = function (e) {
      function t(e) {
        return x(this, t), k(this, E(t).call(this, e));
      }

      return C(t, o.a.PureComponent), S(t, [{
        key: "render",
        value: function value() {
          var e = this.props.icon;
          return o.a.createElement("span", {
            className: "rightControl"
          }, e);
        }
      }]), t;
    }(),
        A = function (e) {
      function t(e) {
        return x(this, t), k(this, E(t).call(this, e));
      }

      return C(t, o.a.PureComponent), S(t, [{
        key: "render",
        value: function value() {
          var e = this.props.icon;
          return o.a.createElement("span", {
            className: "leftControl"
          }, e);
        }
      }]), t;
    }();

    function M(e) {
      return (M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function U(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function B(e, t) {
      return !t || "object" !== M(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function D(e) {
      return (D = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function F(e, t) {
      return (F = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var q = function (e) {
      function t(e) {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), B(this, D(t).call(this, e));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && F(e, t);
      }(t, o.a.PureComponent), function (e, t, n) {
        t && U(e.prototype, t), n && U(e, n);
      }(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.data,
              n = e.activeIndex,
              r = e.version,
              i = e.animation,
              a = 4 == r ? "carousel-item" : "item",
              u = [];
          return Array.isArray(t) ? (u = t.map(function (e, t) {
            var u, c;

            switch (!0) {
              case !0 === i && t > n && 4 == r:
                u = "carousel-item-right", c = "carousel-item-next";
                break;

              case !0 === i && t > n:
                u = "right", c = "next";
                break;

              case !0 === i && t < n && 4 == r:
                u = "carousel-item-left", c = "carousel-item-prev";
                break;

              case !0 === i && t < n:
                u = "left", c = "prev";
            }

            var l = h()(a, c, u);
            return l = t === n ? h()(a, "active") : l, o.a.createElement("div", {
              key: t,
              className: l
            }, e);
          }), o.a.createElement("div", {
            className: "carousel-inner",
            role: "listbox"
          }, u)) : o.a.createElement("div", {
            key: 0,
            className: h()(a, "active")
          }, t);
        }
      }]), t;
    }();

    function V(e) {
      return (V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function W(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function H(e) {
      return (H = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Y(e, t) {
      return (Y = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function z(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function G(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    !function (e, t, n) {
      t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n;
    }(q, "defaultProps", {
      data: [],
      activeIndex: 0,
      direction: null,
      version: 3
    });

    var J = function (e) {
      function t(e) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), G(z(z(n = function (e, t) {
          return !t || "object" !== V(t) && "function" != typeof t ? z(e) : t;
        }(this, H(t).call(this, e)))), "visibilitychange", function () {
          (document.hidden || n.props.hidden) && n.props.pauseOnVisibility ? n._pause() : n._autoPlay();
        }), G(z(z(n)), "_checkChildrenLength", function () {
          var e = n.props.children;
          Array.isArray(e) && e.length > 0 && n._autoPlay();
        }), G(z(z(n)), "_autoPlay", function () {
          n._pause(), n.props.autoplay && n._play();
        }), G(z(z(n)), "slideNext", function () {
          var e = n.state.activeIndex,
              t = n.props.wrap,
              r = e + 1;

          if (r > n.props.children.length - 1) {
            if (!t) return;
            r = 0;
          }

          n.safeSetState({
            activeIndex: r,
            direction: "next"
          });
        }), G(z(z(n)), "goToSlide", function (e) {
          n.timeout && clearTimeout(n.timeout), n.setState({
            activeIndex: e
          });
        }), G(z(z(n)), "slidePrev", function () {
          var e = n.state.activeIndex,
              t = n.props.wrap,
              r = e - 1,
              o = n.props.children.length;

          if (r < 0) {
            if (!t) return;
            r = o - 1;
          }

          n.setState({
            activeIndex: r,
            direction: "prev"
          });
        }), G(z(z(n)), "_handleMouseOver", function () {
          n._pause();
        }), G(z(z(n)), "_handleMouseOut", function () {
          n.isPaused && n.props.autoplay && n._play();
        }), G(z(z(n)), "_pause", function () {
          n.isPaused = !0, n.timeout && clearTimeout(n.timeout);
        }), G(z(z(n)), "_play", function () {
          n.isPaused = !1, n._waitForNext();
        }), G(z(z(n)), "_indClick", function (e, t) {
          n.timeout && clearTimeout(n.timeout), n.setState({
            activeIndex: e,
            direction: t
          }), n.isPaused = !1;
        }), G(z(z(n)), "_controlsClick", function (e) {
          n.timeout && clearTimeout(n.timeout), n.isPaused = !1, "prev" == e ? n.slidePrev() : n.slideNext();
        }), G(z(z(n)), "render_ind", function () {
          var e = n.props,
              t = e.children,
              r = e.indicators,
              i = n.state.activeIndex;
          if (r) return o.a.createElement(w, {
            data: t,
            activeIndex: i,
            indClick: n._indClick
          });
        }), G(z(z(n)), "render_control", function () {
          var e = n.props,
              t = e.children,
              r = e.controls,
              i = e.leftIcon,
              a = e.rightIcon,
              u = e.version;
          if (r) return o.a.createElement(R, {
            dataLength: t.length,
            leftIcon: i,
            rightIcon: a,
            prev: n.slidePrev,
            next: n.slideNext,
            controlsClick: n._controlsClick,
            version: u
          });
        }), n.state = {
          activeIndex: n.props.defaultActiveIndex,
          className: h()("carousel slide", n.props.className)
        }, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && Y(e, t);
      }(t, y), function (e, t, n) {
        t && W(e.prototype, t), n && W(e, n);
      }(t, [{
        key: "componentDidUpdate",
        value: function value(e, t) {
          if (this._checkChildrenLength(), this.props.autoplay !== e.autoplay && this._autoPlay(), t.activeIndex !== this.state.activeIndex) {
            var n = this.state,
                r = n.direction,
                o = n.activeIndex;
            this.props.onSelect(o, r);
          }
        }
      }, {
        key: "init",
        value: function value() {
          this._checkChildrenLength();
        }
      }, {
        key: "unmount",
        value: function value() {
          this.timeout && clearTimeout(this.timeout);
        }
      }, {
        key: "_waitForNext",
        value: function value() {
          this.timeout = setTimeout(this.slideNext, this.props.slideshowSpeed);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              n = e.version,
              r = this.state,
              i = r.activeIndex,
              a = r.className,
              u = this.props.animation;
          return o.a.createElement("div", {
            className: h()(a),
            onMouseOver: this._handleMouseOver,
            onMouseOut: this._handleMouseOut
          }, this.render_ind(), o.a.createElement(q, {
            animation: u,
            data: t,
            activeIndex: i,
            version: n
          }), this.render_control());
        }
      }]), t;
    }();

    G(J, "defaultProps", {
      indicators: !0,
      controls: !0,
      slideshowSpeed: 7e3,
      defaultActiveIndex: 0,
      wrap: !0,
      autoplay: !0,
      children: [],
      animation: !0,
      className: "",
      version: 3,
      pauseOnVisibility: !1,
      hidden: !1,
      onSelect: function onSelect() {}
    }), n.d(t, "React_Bootstrap_Carousel", function () {
      return J;
    });
    t.default = J;
  }]);
});